namespace app.toolbar {

    'use strict';

    import IHttpService = angular.IHttpService;
    import Properties = app.support.constants.Properties;
    
    declare var SystemJS;

    export class InformacaoService {

        private static serviceApi = "/integracoes-processos/api/processos";

        private static TAMANHO_HISTORICO_CONSULTAS: number = 3;

        private consultas = new Map();

        /** @ngInject */
        public constructor(private $http: IHttpService,
                           private properties: Properties,
                           private $cookies,
                           public $state,
                           private $q: ng.IQService,
                           private stylesLoadingService: app.support.StylesLoadingService,
                           private $ocLazyLoad: oc.ILazyLoad,
                           private $rootScope: ng.IRootScopeService,
                           private $mdSidenav: ng.material.ISidenavService) {
            if (!this.$cookies.get("historico")) {
                this.$cookies.put("historico", JSON.stringify([]));
            }

            $rootScope.$on("stf:ui1:visualizar-informacao-sidenav", (event, args) => {
                this.registrarInformacao(args)
                    .then(() => this.$mdSidenav("info-viewer").open());
            });
        }

        /**
         * Recupera a lista de informações para uma data identificação.
         *
         * @param identificacao a identificação da informação desejada
         * @returns {*} a lista de informações
         */
        public informacoes(identificacao: string): ng.IPromise<any>  {
            let url = `${this.properties.apiUrl + InformacaoService.serviceApi}`;
            return this.$http
                .get(`${url}?identificacao=${encodeURIComponent(identificacao)}`)
                .then((response: ng.IHttpPromiseCallbackArg<any>) => response.data);
        }

        /**
         * Registra a um determinado tipo de consulta, como a consulta de processo, por exemplo.
         *
         * <p> Usado para viabilizar o mecanismo de consultas rápidas.
         *
         * @param consulta um tipo de consulta
         */
        public registrarConsulta(consulta) {            
            return this
                .carregarDependencias(consulta.dependencias)
                .then(() => this.consultas.set(consulta.tipo, consulta));
        }

        /**
         * Indica se a consulta rápida está disponível. Estará disponível se um consulta estiver registrada,
         * se uma informação estiver registrada e se a esta consulta não estiver sendo usada pelo
         * usuário no momento.
         */
        public getConsulta() {
            return this.getViewer() && this.getInformacao() && this.$state.current.name !== this.getViewer().state;
        }

        /**
         * Retorna o tipo de viewer registrado.
         */
        public getViewer(): any {
            if (this.getInformacao()) {
                return this.consultas.get(this.getInformacao().tipo);
            }
            return null;
        }

        /**
         * Usado para registrar uma informação consultada como, por exemplo, um processo.
         *
         * @param informacao a informação consultada
         */
        public registrarInformacao(informacao): ng.IPromise<void> {
            let promise = this.carregarDependencias(informacao["dependencias"]);
            return promise.then(() => {                    
                // A informação consultada deve ser armazenada em um histórico de informações consultadas recentemente
                let historico = this.getHistorico();
    
                // Verificando se a informação já está no histórico de consultas recentes
                let index = historico.findIndex(h => h["identificacao"] === informacao["identificacao"]);
    
                if (index >= 0) {
                    // Se estiver no histórico, remove e recoloca no topo da lista
                    historico.splice(index, 1);
                    historico.unshift(informacao);
                } else {
                    // Caso contrário, remove a mais velha,
                    // caso tenha alçado o número máximo de consultas do histórico, e coloca a nova consulta

                    if (historico.length === InformacaoService.TAMANHO_HISTORICO_CONSULTAS) {
                        historico.pop();
                    }
                    historico.unshift(informacao);
                }
    
                // Por fim, atualiza o cookie com a o histórico renovado
                this.$cookies.put("historico", JSON.stringify(historico));
            });
        }

        /**
         * Recupera a última informação consultada
         */
        public getInformacao() {
            // Se houver alguma consulta registrada no histórico, recupera a mais recente
            if (this.getHistorico().length > 0) {
                return this.getHistorico()[0];
            };
            // Caso contrário, retorna null
            return null;
        }

        /**
         * Retorna o histórico de consultas do cookie correspondente.
         */
        public getHistorico() {
            return JSON.parse(this.$cookies.get("historico"));
        }

        /**
         * Carrega uma lista de módulos demandados pelo cliente.
         * 
         * @param dependencias os módulo necessários
         * 
         * TODO Rodrigo Barreiros Me parece que esse código quebra a coesão desta service. Acho que uma
         * solução melhor seria centralizar o código responsável pelo mecanismo de modularização 
         * em um componente específico.
         */
        public carregarDependencias(dependencias: string[]): ng.IPromise<any> {
            if (dependencias) {
                return this.$q.all(dependencias.map((dependencia) => {
                    let contexto = dependencia.split("/")[0];
                    let bundle: string = contexto + '/bundle';
                    let styleUrl = SystemJS.baseURL + contexto + '/style.css';
                    return this.$q.all([System.import(bundle), this.stylesLoadingService.loadStyle(styleUrl)]);
                })).then(() => {
                    return this.$q.all(dependencias.map((modulePath) => {
                        return this.$q.when(System.import(modulePath).then((importedModule) => {
                            let newModule = importedModule;

                            if (!importedModule.name) {
                                var key = Object.keys(importedModule);
                                newModule = importedModule[key[0]];
                            }

                            return this.$q.when(this.$ocLazyLoad.load(newModule));
                        }));
                    }));
                });
            } else {
                return this.$q.when();
            }

        }

    }

    angular.module("app.toolbar").service("informacaoService", InformacaoService);

}
